export const useBrowserSupported = () => {
  let browserSupported = true;

  if (typeof CSSLayerBlockRule === 'undefined') {
    browserSupported = false;
  }

  return browserSupported;
};
